<template>
  <div>
    <vs-table stripe :data="result.results.groups">
    <template slot="thead" class="thead-dark">
      <vs-th>Regla</vs-th>
      <vs-th>Peso de la categoría</vs-th>
      <vs-th>Resultado</vs-th>
      <vs-th>Porcentaje</vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr
        v-for="(group, index) in data"
        :key="index"
        v-bind:class="{'text-danger': group.result <= 50}"
        v-if="group.rules.length > 0">
        <vs-td><strong>{{group.name}}</strong></vs-td>
        <vs-td>{{group.weight|fixNumber}} %</vs-td>
        <vs-td>{{group.result|fixNumber}} %</vs-td>
        <vs-td>{{group.score|fixNumber}} %</vs-td>

        <template slot="expand">
          <div class="con-expand-users w-full">
            <vs-table :data="group.rules">
              <template slot="thead">
                <vs-th>Indicadores</vs-th>
                <vs-th>Peso indicador</vs-th>
                <vs-th>Puntaje indicador</vs-th>
                <vs-th>Calificación indicador</vs-th>
                <vs-th>Tipo de análisis</vs-th>
                <vs-th>Respuesta</vs-th>
                <vs-th>Limite inferior</vs-th>
                <vs-th>Limite superior</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr
                  v-for="rule in data"
                  v-bind:class="{'text-danger': rule.score <= 50}"
                  :key="`trx-${rule.identity_name}`">
                  <vs-td><strong>{{rule.name}}</strong></vs-td>
                  <vs-td>{{rule.weight|fixNumber}}%</vs-td>
                  <vs-td>{{rule.result|fixNumber}}</vs-td>
                  <vs-td>{{rule.score|fixNumber}}%</vs-td>
                  <vs-td>{{rule.analysis_type.type}}</vs-td>
                  <vs-td>{{rule.answer|answer}}</vs-td>
                  <vs-td>{{rule.worst_value}}</vs-td>
                  <vs-td>{{rule.best_value}}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </template>
      </vs-tr>
    </template>
  </vs-table>
  </div>
</template>

<script>
import {fixNumber} from "@/filters/NumberFilters";

export default {
  name: "RiskModelResultTable",
  props: ['result'],
  filters: {
    fixNumber,
    answer(val) {
      if (val === 'Si' || val === 'No') {
        return val;
      }
      return val.toFixed(2)
    }
  }
}
</script>

<style scoped>

</style>
